import React from 'react';
import {
  Body,
  Box,
  CheckIcon,
  List,
  ListItem,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

const ValuePropositionList = () => {
  const { t } = useTranslation();
  return (
    <List.Base>
      <ListItem icon={<CheckIcon size={'medium'} color={'neutral.90'} />}>
        <Box pb="base" pl="2">
          <Body type="base" color="neutral.90">
            {t('supportarea.mytripslogin.banner.text1')}
          </Body>
        </Box>
      </ListItem>
      <ListItem icon={<CheckIcon size={'medium'} color={'neutral.90'} />}>
        <Box pb="base" pl="2">
          <Body type="base" color="neutral.90">
            {t('supportarea.mytripslogin.banner.text2')}
          </Body>
        </Box>
      </ListItem>
      <ListItem icon={<CheckIcon size={'medium'} color={'positive.default'} />}>
        <Box pb="base" pl="2">
          <Body type="base" color="green.50">
            {t('supportarea.mytripslogin.banner.text3')}
          </Body>
        </Box>
      </ListItem>
    </List.Base>
  );
};

export default ValuePropositionList;
